import React from 'react';
import {
	Grid,
	FormControlLabel,
	Switch,
	TextField,
	Checkbox,
	Box,
	useMediaQuery,
} from '@mui/material';
import { useTheme, Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { CheckoutCommentField } from 'common/types';
import { useTranslation } from 'services/localization';

interface Props {
	value: CheckoutCommentField;
	onChange: (value: CheckoutCommentField) => void;
}
const CommentFieldSettings = (props: Props) => {
	const classes = useStyles();
	const { value, onChange } = props;
	const { t } = useTranslation();
	const theme = useTheme();
	const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));

	return (
		<Grid item xs={12} md={6}>
			<FormControlLabel
				style={{ alignItems: 'center' }}
				control={
					<Switch
						color="primary"
						checked={value.enabled}
						onChange={(e) => onChange({ ...value, enabled: e.target.checked })}
					/>
				}
				label={t('channels.enableCustomField', 'Show custom field')}
			/>

			<Box mt={isSmallScreen && !value.enabled ? 0 : 3} />
			{value.enabled && (
				<Box className={classes.commentFieldWrapper}>
					<TextField
						label={t('channels.commentField.title', 'Title')}
						className={classes.commentFieldTextField}
						placeholder={t('channels.commentField.comment')}
						variant="outlined"
						value={value.label.def}
						onChange={(e) =>
							onChange({
								...value,
								label: {
									...value.label,
									def: e.target.value,
								},
							})
						}
						InputProps={{
							className: classes.input,
						}}
						inputProps={{
							maxLength: 80,
						}}
						InputLabelProps={{
							shrink: true,
						}}
						fullWidth
					/>
					<FormControlLabel
						control={
							<Checkbox
								color="primary"
								checked={value.required}
								onChange={(e) => onChange({ ...value, required: e.target.checked })}
							/>
						}
						label={t('channels.commentField.required', 'Mark as required')}
					/>
				</Box>
			)}
		</Grid>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		commentFieldTextField: {
			marginTop: theme.spacing(1),
		},
		input: {
			background: theme.palette.background.paper,
		},
		commentFieldWrapper: {
			marginLeft: theme.spacing(6),
		},
	}),
);

export default CommentFieldSettings;
